{
  "version": 1,
  "asset_id": "17ea5e69-6039-4ad0-9713-9ab3997c13e3",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/17ea5e69-6039-4ad0-9713-9ab3997c13e3/svc-ppc-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/17ea5e69-6039-4ad0-9713-9ab3997c13e3/svc-ppc-1200.avif",
  "original_filename": "svc-ppc-1200.avif",
  "size": 11689,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:54Z"
}
